module.exports = __webpack_public_path__ + "static/img/ls15.32e01f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls15.png
// module id = fLwI
// module chunks = 12